// Global header button pop animation for all pages

document.addEventListener('DOMContentLoaded', function() {
  // Find all header and global buttons
  var buttons = document.querySelectorAll('.header__button, .button, .btn-pop');
  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      btn.classList.remove('pop-animate');
      // Force reflow to restart animation
      void btn.offsetWidth;
      btn.classList.add('pop-animate');
    });
    // Remove animation class after animation ends
    btn.addEventListener('animationend', function() {
      btn.classList.remove('pop-animate');
    });
  });
});
